<script lang="ts" setup>
import Toast, { type ToastProps } from 'primevue/toast';

const props = defineProps</* @vue-ignore */ ToastProps>();
</script>

<template>
  <Toast v-bind="props" />
</template>
